import { requestApi } from './Api';

export const createProductCategory = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: 'api/product/category/create',
    navigate,
    onError,
    onSuccess,
    params
  });

export const deleteProductCategory = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: 'api/product/category/delete',
    navigate,
    onError,
    onSuccess,
    params
  });
